import { Socket } from 'phoenix'

import { AsyncLock } from '@/utils/lock'

import environment from '../environment'
import store from '../store'
import http from './http'

const socket = new Socket(environment.WS_URL, {
  params: { userToken: store.state.auth.userToken.token },
})
socket.onError(async () => {
  const token = await http.auth.updateRefreshToken()
  socket.params = () => ({ userToken: token })
})

const lock = new AsyncLock()
const CHANNELS = {}

export async function registerChannelListener(
  topic,
  event,
  callback,
  connect = () => {}
) {
  await lock.lock()
  // This async should be here to avoid concurrency issues on CHANNELS[topic]
  const jwtToken = await http.auth.updateRefreshToken()
  try {
    if (!CHANNELS[topic]) {
      const channel = socket.channel(topic, {
        email: store.state.auth.user.email,
        userToken: jwtToken,
      })

      channel
        .join()
        .receive('ok', connect)
        .receive('error', (resp) => {
          console.error(resp)
        })

      CHANNELS[topic] = channel
    }

    return CHANNELS[topic].on(event, callback)
  } finally {
    lock.unlock()
  }
}

export function removeChannelListener(topic, event, ref) {
  CHANNELS[topic].off(event, ref)
}

export async function registerChannelListenerWithCancel(
  topic,
  event,
  callback
) {
  const ref = await registerChannelListener(topic, event, callback)

  return () => removeChannelListener(topic, event, ref)
}

// eslint-disable-next-line no-unused-vars
export function connectSocket(params = null) {
  socket.connect(params)
}

export function disconnectSocket() {
  socket.disconnect()
}

export default socket
